// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"166":"public-app","378":"admin-app"}[chunkId] || chunkId) + "." + {"166":"fe345158","378":"b30d2ca3","577":"60f0030a"}[chunkId] + ".chunk.css";
};